import { EventEmitter } from 'eventemitter3';

import { DiscardDialogProps } from './DiscardDialog.data';

export interface DiscardDialogEventEmitterType {
  show: () => void;
  result: (result: boolean | undefined) => void;
  hide: () => void;
  block: () => void;
  unblock: () => void;
  message: (message: DiscardDialogProps) => void;
}

export const DiscardDialogEmitter = new EventEmitter<DiscardDialogEventEmitterType>();
